module.exports = __webpack_public_path__ + "static/media/application_9.b2264d8f.png";